<template>
  <el-card>
    <div>
      <el-row type="flex" justify="end">
        <el-button @click="goadd()" type="primary">新建宣传位</el-button>
      </el-row>
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="code" label="调显码" />
        <!-- <el-table-column prop="title" label="推荐位标题" width="120" /> -->
        <el-table-column prop="mission" label="形式"  />
        <el-table-column prop="info" label="内容数量" />
        <el-table-column prop="content" label="备注"/>
        <el-table-column fixed="right" label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
            <el-button @click="del(scope.row)" type="text" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="tac mt">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size="limit"
          :current-page="page"
          background
          layout="prev, pager, next"
          :total="total"
        ></el-pagination>
      </div>

      <el-alert
        title="警告"
        type="warning"
        description="• 请不要随意删除，以免造成内容无法显示。但是可以根据需要进行内容修改。
        • 本功能需要前端开发配合“调显码”调取显示到相应页面。"
        show-icon
      ></el-alert>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      page: 1,
      total: 0, // 分页总数
      limit: 20,
      tableData: []
    };
  },
  methods: {
    getnoticList: async function() {
      var res = await this.$http.get(
        `/v1/advertise/selectAdvertiseList?page=${this.page}`
      );
      var { code, message, data, total } = res.data;
      if (code == 0) {
        this.total = total;
        this.tableData = data;
      }
    },
    edit: async function(row) {
      this.$router.push({
        path: `/AdvertiseDetail`,
        query: {
          id: row.id,
          code: row.code
        }
      });
    },
    goadd: function() {
      this.$router.push("/AdvertiseDetail");
    },
    del: function(row) {
      this.$confirm("确定删除吗？", "提示", {
        confirmTextButton: "确定",
        cancelTextButton: "取消",
        type: "warning"
      })
        .then(async () => {
          var id = row.id;
          var res = await this.$http.post(`/v1/advertise/deleteGroup?id=${id}`);
          var { code, data, message } = res.data;
          if (code == 0) {
            this.$message.success("删除成功！");
            this.getnoticList();
          } else {
            this.$message.error(message);
          }
        })
        .catch(() => {});
    },
    handleCurrentChange: function(val) {
      this.page = val;
      this.getnoticList();
    }
    /*,
        downline:async function(row){
          var id= row.id;
          var res = await this.$http.get(
            `/v1/notice/downline?id=${id}`
          )
          var {code,message,data}=res.data;
          if(code==0){
            this.$message.success(message);
          }else {
            this.$message.error(message);
          }
        },
        */
  },
  mounted() {
    this.getnoticList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/backgroundMg/advertise-mg/AdvertiseGroup.vue